document.addEventListener('DOMContentLoaded', function() {
  const dateSpan = document.querySelector('.dynamic-date');
  if (dateSpan) {
    const lastModified = new Date(document.lastModified);
    const options = { month: 'short', day: 'numeric', year: 'numeric' };
    dateSpan.textContent = lastModified.toLocaleDateString('en-US', options);
  }
});

class FeaturedKarts {
  constructor() {
    this.initLoadMore();
  }

  initLoadMore() {
    const loadMoreBtn = document.querySelector('.load-more-btn');
    if (!loadMoreBtn) return;
    
    loadMoreBtn.addEventListener('click', (e) => {
      e.preventDefault();
      this.showAllCards(e.currentTarget);
    });
  }

  showAllCards(button) {
    const sectionId = button.dataset.sectionId;
    const grid = document.getElementById(`kartsGrid-${sectionId}`);
    const container = button.closest('.load-more-container');
    
    // Add class to show all cards
    grid.classList.add('show-all');
    
    // Hide the load more button
    container.classList.add('hide');
  }
}

// Initialize
document.addEventListener('DOMContentLoaded', () => {
  new FeaturedKarts();
});